<template>
  <Layout>
    <PageHeader
      title="Edit Kategori Video"
      pageTitle="KMS"
    />

    <div class="card">
      <div class="card-body">

        <!-- Loading -->
        <div v-if="loadingPage" class="text-center py-5">
          <i class="mdi mdi-loading mdi-spin font-size-24"></i>
          <p class="mt-2">Memuat data kategori...</p>
        </div>

        <!-- Form -->
        <form v-else @submit.prevent="submit">

          <!-- Nama Kategori -->
          <div class="form-group">
            <label>
              Nama Kategori <span class="text-danger">*</span>
            </label>
            <input
              v-model="form.name"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors.name }"
              placeholder="Nama kategori"
            />
            <div v-if="errors.name" class="invalid-feedback">
              {{ errors.name }}
            </div>
          </div>

          <!-- Deskripsi -->
          <div class="form-group">
            <label>Deskripsi</label>
            <textarea
              v-model="form.description"
              rows="3"
              class="form-control"
              placeholder="Deskripsi singkat kategori (opsional)"
            ></textarea>
          </div>

          <!-- Status -->
          <div class="form-group">
            <label>Status</label>
            <div class="custom-control custom-switch">
              <input
                type="checkbox"
                class="custom-control-input"
                id="is_active"
                v-model="form.is_active"
              />
              <label class="custom-control-label" for="is_active">
                {{ form.is_active ? 'Aktif' : 'Nonaktif' }}
              </label>
            </div>
          </div>

          <!-- Action -->
          <div class="d-flex justify-content-end mt-4">
            <button
              type="button"
              class="btn btn-secondary mr-2"
              @click="goBack"
            >
              Batal
            </button>

            <button
              type="submit"
              class="btn btn-primary"
              :disabled="loadingSubmit"
            >
              <i v-if="loadingSubmit" class="mdi mdi-loading mdi-spin"></i>
              Simpan Perubahan
            </button>
          </div>

        </form>

      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  components: {
    Layout,
    PageHeader,
  },

  data() {
    return {
      id: null,
      loadingPage: true,
      loadingSubmit: false,
      form: {
        name: "",
        description: "",
        is_active: true,
      },
      errors: {},
    };
  },

  created() {
    this.id = this.$route.params.id;
    this.fetchDetail();
  },

  methods: {
    async fetchDetail() {
      try {
        const res = await axios.get(
          `/api/v1/master/kms/video/kategori/${this.id}`
        );

        const data = res.data.data;

        this.form.name = data.name;
        this.form.description = data.description;
        this.form.is_active = !!data.is_active;
      } catch (err) {
        Swal.fire(
          "Error",
          "Gagal memuat data kategori",
          "error"
        );
        this.goBack();
      } finally {
        this.loadingPage = false;
      }
    },

    validate() {
      this.errors = {};

      if (!this.form.name) {
        this.errors.name = "Nama kategori wajib diisi";
      } else if (this.form.name.length < 3) {
        this.errors.name = "Nama kategori minimal 3 karakter";
      }

      return Object.keys(this.errors).length === 0;
    },

    async submit() {
      if (!this.validate()) return;

      this.loadingSubmit = true;

      try {
        await axios.put(
          `/api/v1/master/kms/video/kategori/${this.id}`,
          this.form
        );

        Swal.fire({
          icon: "success",
          title: "Berhasil",
          text: "Kategori video berhasil diperbarui",
        });

        this.goBack();
      } catch (err) {
        if (err.response && err.response.status === 422) {
          const backendErrors = err.response.data.errors || {};
          Object.keys(backendErrors).forEach((key) => {
            this.errors[key] = backendErrors[key][0];
          });
        } else {
          Swal.fire("Error", "Gagal menyimpan perubahan", "error");
        }
      } finally {
        this.loadingSubmit = false;
      }
    },

    goBack() {
      this.$router.push({
        name: "kms-video-kategori-list",
      });
    },
  },
};
</script>

<style scoped>
.form-group label {
  font-weight: 600;
}
</style>
